import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Box, Flex, Button } from "theme-ui"
import styled from "@emotion/styled"

const TestiNameBox = styled(Button)`
    background: ${(props) => props.theme.colors.light_blue_2};
    margin-bottom: 1rem;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    & p {
        color: ${(props) => props.theme.colors.light_blue_1};
        margin: 0;
    }
`
const query = graphql`
    {
        testimonials: allStrapiTestimonial(
            filter: {
                company: { shortname: { eq: "EIP" } }
                type: { eq: "client" }
            }
        ) {
            edges {
                node {
                    author
                    quote
                }
            }
        }
    }
`
// markup
const IndexPage = () => {
    const data = useStaticQuery(query)
    return data.testimonials.edges.map((testi, idx) => (
        <Flex
            sx={{
                borderBottom: "1px dashed #28a8e0",
                flexDirection: "column",
                marginBottom: "1.5rem"
            }}
            key={idx}
        >
            <Box>
                <div
                    dangerouslySetInnerHTML={{ __html: testi.node.quote }}
                ></div>
            </Box>
            <Flex sx={{ justifyContent: "right" }}>
                <TestiNameBox>
                    <p>{testi.node.author}</p>
                </TestiNameBox>
            </Flex>
        </Flex>
    ))
}

export default IndexPage
